// @ts-nocheck
import { createAction, createAsyncActionTypes } from '../../../core/store/actionCreators';

export const FETCH_TOKEN = 'auth/fetchToken';
export const {
  pending: FETCH_TOKEN_PENDING,
  fulfilled: FETCH_TOKEN_FULFILLED,
  rejected: FETCH_TOKEN_REJECTED,
} = createAsyncActionTypes(FETCH_TOKEN);

export const FETCH_CURRENT_USER = 'auth/fetchCurrentUser';
export const {
  pending: FETCH_CURRENT_USER_PENDING,
  fulfilled: FETCH_CURRENT_USER_FULFILLED,
  rejected: FETCH_CURRENT_USER_REJECTED,
} = createAsyncActionTypes(FETCH_CURRENT_USER);

export const SET_AUTHENTICATED = 'auth/setAuthenticated';
export const SET_AUTHENTICATING = 'auth/setAuthenticating';
